import Image from 'next/image';
import { useMemo } from 'react';
import { twJoin } from 'tailwind-merge';

import { Link } from '@/components/Link';
import { Paths } from '@/utils/paths';

export type SolutionsMenuItemProps = {
  type: 'store' | 'benefit' | 'network';
  content: LayoutContent;
};

export function SolutionsMenuItem({ type, content }: SolutionsMenuItemProps) {
  const {
    storeLogoUrl,
    solutionsStore,
    benefitsLogoUrl,
    solutionsBenefit,
    networkLogoUrl,
    solutionsNetwork,
  } = content.topbar;

  const { label, href, logo, color } = useMemo(() => {
    if (type === 'store') {
      return {
        label: solutionsStore,
        href: Paths.STORES,
        logo: {
          src: storeLogoUrl,
          height: 24,
          width: 100,
          alt: 'Store',
        },
        color: 'text-store-primary',
      };
    }

    if (type === 'benefit') {
      return {
        label: solutionsBenefit,
        href: Paths.BENEFITS,
        logo: {
          src: benefitsLogoUrl,
          height: 24,
          width: 120,
          alt: 'Benefit',
        },
        color: 'text-benefit-primary',
      };
    }

    return {
      label: solutionsNetwork,
      href: Paths.NETWORKS,
      logo: {
        src: networkLogoUrl,
        height: 24,
        width: 128,
        alt: 'Network',
      },
      color: 'text-network-primary',
    };
  }, [type]);

  return (
    <Link
      href={href}
      className="w-full px-4 py-2 hover:bg-gray-50 hover:no-underline"
    >
      <Image
        src={logo.src}
        height={logo.height}
        width={logo.width}
        className="self-start"
        alt={logo.alt}
      />

      <div className="mt-2 flex justify-end pr-2">
        <p className={twJoin('max-w-[7.5rem] text-left text-sm', color)}>
          {label}
        </p>
      </div>
    </Link>
  );
}
